export default "__VITE_ASSET__CaUNMxKf__"